import React, { useState } from "react";
import CloseForm from "./CloseForm";
import LoadingScreen from "../Homepage/LoadingScreen";
import { toast } from "react-toastify";
import axiosInstance from "../../api";
import Swal from "sweetalert2";

function AddKilometreRate({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  rateupdatedata,
}) {
  const [rateData, setrateData] = useState({
    year: triggerupdate ? rateupdatedata?.year : "",
    rate: triggerupdate ? rateupdatedata?.kmRate : "",
  });
  const [loading, setloading] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/KilometreRate/Update`;
      axiosInstance
        .put(url, {
          Year: rateData.year,
          KmRate: rateData.rate,
        })
        .then((res) => {
          toast.success(res.data, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/KilometreRate/Create`;
      axiosInstance
        .post(url, {
          Year: rateData.year,
          KmRate: rateData.rate,
        })
        .then((response) => {
          toast.success(response.data, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error(error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error(error?.response?.data, {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }

  return (
    <form className="add-currency-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Year{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <select
          required
          onChange={(e) => setrateData({ ...rateData, year: e.target.value })}
          disabled={triggerupdate}
        >
          <option value="">Select Year</option>
          {Array.from({ length: 100 }, (_, i) => (
            <option
              selected={rateData.year == new Date().getFullYear() - (20 - i)}
              value={String(new Date().getFullYear() - (20 - i))}
            >
              {new Date().getFullYear() - (20 - i)}
            </option>
          ))}
        </select>
        {/*<span style={{ color: "red" }}>{nameMessage}</span>*/}
      </blockquote>
      <blockquote>
        <label>
          Rate per Kilometre{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>

        <input
          type="text"
          placeholder="Enter Rate Per Kilometre"
          onChange={(e) => {
            const value = e.target.value;

            // Allow only numbers with up to 2 decimal places
            if (/^\d*\.?\d{0,2}$/.test(value)) {
              setrateData({
                ...rateData,
                rate: value,
              });
            }
          }}
          value={rateData.rate}
          required
        />
        {/*<span style={{ color: "red" }}>{codeMessage}</span>*/}
      </blockquote>

      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddKilometreRate;
